import { ChangeDetectorRef, Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { CapsuleService } from '../../services/capsule.service';
import { LayoutService } from '../../services/layout.service';
import { MonacoPreviewDialog } from '../../components/dialogs/monacopreview/monaco.preview.dialog';
import { NotificationHelper } from '../../helpers/notification.helper';

@Component({
    selector: 'capsule-content-settings',
    templateUrl: './capsule.content.settings.html',
    styleUrls: ['./capsule.content.settings.css']
})
export class CapsuleContentSettings implements OnInit {
    CapsuleVersions = [];
    SelectedVersion: any;
    ShowChanged = false;

    constructor(private cdRef: ChangeDetectorRef, private service: CapsuleService) {
    }

    ngOnInit(): void {
        LayoutService.Loading.next(true);
        this.service.GetLatestVersions().subscribe(x => {
            LayoutService.Loading.next(false);
            if (x) {
                const list = [];
                x.forEach((y: any) => {
                    list.push({ Info: y });
                });
                this.CapsuleVersions = list;
                if (list.length == 1) {
                    this.SelectedVersion = list[0];
                    this.onVersionChange();
                } else {
                    this.cdRef.detectChanges();
                }
            }
        });
    }

    onVersionChange() {
        const sel = this.SelectedVersion;
        if (sel && !sel.Data) {
            sel.Data = {};
            LayoutService.Loading.next(true);
            this.service.GetCapsuleContent(sel.Info).subscribe(x => {
                LayoutService.Loading.next(false);
                if (x && x.Types) {
                    x.Types.forEach((y: any) => {
                        y.HasChanges = y.Entries && y.Entries.some((z: any) => z.Changes);
                    });
                }
                sel.Data = x;
                this.cdRef.detectChanges();
            });
        }
    }

    saveClick() {
        const sel = this.SelectedVersion;
        if (sel && sel.Info && sel.Data && sel.Data.Types) {
            const data = {
                CompareVersionID: sel.Info.ID,
                CompareVersion: JSON.stringify(sel.Info),
                ExcludedItems: {}
            };
            sel.Data.Types.forEach((x: any) => {
                const exclude = [];
                x.Entries.forEach((y: any) => {
                    if (!y.Include) {
                        exclude.push(y.SID);
                    }
                });
                if (exclude.length > 0) {
                    data.ExcludedItems[x.TypeName] = exclude;
                }
            });
            this.service.SaveCapsuleContentSaveData(data).subscribe(() => {
                sel.HasChanges = false;
                NotificationHelper.Success('@@Erfolgreich gespeichert', '@@Speichern');
            });
        }
    }

    viewChanges(entry: any) {
        if (entry && entry.Changes) {
            if (entry.Changes.OldData) {
                if (entry.Changes.NewData) {
                    MonacoPreviewDialog.ShowDialog({
                        Document: entry.Changes.OldData,
                        Original: entry.Changes.NewData
                    }, '@@Vergleichen');
                } else {
                    MonacoPreviewDialog.ShowDialog({
                        Document: entry.Changes.OldData
                    }, '@@Inhalt');
                }
            } else {
                MonacoPreviewDialog.ShowDialog({
                    Document: entry.Changes.NewData
                }, '@@Inhalt');
            }
        }
    }

    includeAll(item: any) {
        if (this.SelectedVersion) {
            this.SelectedVersion.HasChanges = true;
        }
        if (item && item.Entries) {
            item.Entries.forEach((x: any) => {
                if (x.Changes) {
                    x.Include = item.IncludeAll;
                }
            });
        }
        this.cdRef.detectChanges();
    }
}

@Pipe({
    name: 'ctFilter',
    pure: false
})
export class CapsuleTypeFilterPipe implements PipeTransform {
    transform(items: any[], showChanged: boolean) {
        if (items && showChanged) {
            return items.filter((x: any) => x.HasChanges);
        }
        return items;
    }
}

@Pipe({
    name: 'ctEntryFilter',
    pure: false
})
export class CapsuleTypeEntryFilterPipe implements PipeTransform {
    transform(items: any[], showChanged: boolean) {
        if (items && showChanged) {
            return items.filter((y: any) => y.Changes);
        }
        return items;
    }
}

